// @flow
import React, { Component } from 'react'
import { translations } from '../../../shared/localize'
import _ from 'lodash'
import type { StatisticFilter } from '../../types'
import { FiltersWrapper, ElementWrapper } from '../CampaignFilterForm'
import styled from 'styled-components'
import { linkColor } from '../../controls/colors'

const Filter = styled.div`
  background-color: white;
  color: ${linkColor};
  display: flex;
  margin: 2px;
  min-width: 0px;
  box-sizing: border-box;
  border-radius: 2px;
  background-color: 'white';
  border: solid 1px ${linkColor};
`
const FilterText = styled.div`
  border-radius: 2px;
  color: ${linkColor};
  font-size: 85%;
  overflow: hidden;
  padding: 3px 3px 6px 6px;
  text-overflow: ellipsis;
  white-space: nowrap;
  box-sizing: border-box;
`
const FilterCross = styled.div`
  align-items: baseline;
  border-radius: 2px;
  padding-left: 4px;
  padding-right: 4px;
  box-sizing: border-box;
  cursor: pointer;
`

type Props = {|
  statisticFilters: Array<StatisticFilter>,
  onFilterChange: Function
|}

const headerT = translations.table_headers
const signT = translations.campaigns_table.statistic_filter

export default class StatisticFilters extends Component<Props> {
  render() {
    return (
      <FiltersWrapper>
        {_.map(this.props.statisticFilters, (filter, index: number) => {
          return (
            <ElementWrapper key={index} className="t-StatisticFilter">
              <Filter>
                <FilterText>
                  {`${headerT[filter.field]} ${signT[filter.comparison]} ${filter.value}`}
                </FilterText>
                <FilterCross onClick={() => this.removeFilter(filter)}>x</FilterCross>
              </Filter>
            </ElementWrapper>
          )
        })}
      </FiltersWrapper>
    )
  }

  removeFilter(filter: StatisticFilter) {
    const { statisticFilters, onFilterChange } = this.props
    onFilterChange(_.without(statisticFilters, filter))
  }
}
